import { createApp, watch } from 'vue'
import App from './App.vue'
import router from './router';
import { createI18n } from 'vue-i18n';
import messages from '@/locales';
import './assets/styles/styles.scss'
import sanitizeHtml from 'sanitize-html';
import { updateTitle } from './services/titleService';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faCheck, faHome, faTools, faHighlighter, faBurn, faAddressCard, faUsers, faCalendarDay, faBalanceScale, faGavel } from '@fortawesome/free-solid-svg-icons'
import { faMoon, faSun, faQuestionCircle, faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import sharedService from './services/sharedService';
import languageService from './services/languageService';

/* add icons to the library */
library.add(faMoon, faSun, faQuestionCircle, faCheck, faHome, faTools, faHighlighter, faBurn, faAddressCard, faUsers, faCalendarDay, faBalanceScale, faCircleXmark, faGavel);

const savedLanguage = localStorage.getItem('language') || 'es';

const i18n = createI18n({
    locale: savedLanguage,
    messages,
});

const app = createApp(App)
.component('font-awesome-icon', FontAwesomeIcon)
.directive('safe-html', {
    beforeMount(el, binding) {
        el.innerHTML = sanitizeHtml(binding.value, {
            allowedTags: ['p', 'strong', 'em', 'ul', 'li', 'br'],
            allowedAttributes: {}
        });
    }
});

watch(
    () => sharedService.sharedState.title,
    (newTitle) => {
        updateTitle(`${newTitle} - AEPD`);
    }
);

watch(
    () => languageService.languageState.language,
    (newLanguage) => {
      document.documentElement.lang = newLanguage;
    }
);

app.use(router);
app.use(i18n);
app.config.globalProperties.$updateTitle = updateTitle;
app.mount('#app');
